import { useState, useEffect } from "react";

import css from "./Requests.module.css";

import * as requestServices from "../../../../services/requestServices";

import OpenRequests from "./OpenRequests";
import ModalForm from "../../_common/ModalForm";
import AddNewRequest from "./AddNewRequest";
import RequestTable from "./RequestTable";

function Requests() {

    

    const [requests, setRequest] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        requestServices
            .getAll(page || 1)
            .then((result) => {
                setRequest((state) => result.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onAdd = (newData) => {
        setRequest((state) => [...state, newData]);
    };

    const toggleModal = () => setShowModal(!showModal);
    

    return (
        <div className={css.main}>
            <div>
                <RequestTable data={requests} />
            </div>
            <div>
                <div>
                    <button onClick={toggleModal} className={css.button}>
                        +
                    </button>
                    <ModalForm showModal={showModal}>
                        <AddNewRequest data={requests} onAdd={onAdd} toggleModal={toggleModal} />
                    </ModalForm>
                </div>
                <OpenRequests requests={requests} />
            </div>
        </div>
    );
}

export default Requests;
